<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="scmCode"
    >
      <template v-slot:scmName="{ row }">
        <div>No：{{ row.scmNo }}</div>
        <div>
          {{ row.scmName }}
        </div>
        <div>CC：{{ row.businessLicense ? row.businessLicense : '--' }}</div>
      </template>
      <template v-slot:scmMode="{ row }">
        <div>
          {{ row.scmTypeName }}
        </div>
        <div>
          Category：{{ row.scmCategoryName ? row.scmCategoryName : '--' }}
        </div>
        <div class="d-flex">
          <div class="mr-2">
            <el-tag
              size="mini"
              :type="row.isCooperation === 'Y' ? 'success' : 'info'"
            >
              {{ row.isCooperationName }}
            </el-tag>
          </div>
          <div class="mr-2">
            <el-tag
              size="mini"
              :type="
                row.scmMode === 'C'
                  ? 'success'
                  : row.scmMode === 'B'
                  ? ''
                  : 'info'
              "
            >
              {{ row.scmModeName ? row.scmModeName : 'Not set' }}
            </el-tag>
          </div>
        </div>
      </template>
      <template v-slot:scmAddressInfo="{ row }">
        <div>
          {{ row.provinceName }} {{ row.cityName }} {{ row.districtName }}
        </div>
        <div>
          {{ row.scmAddress }}
        </div>
      </template>
      <template v-slot:bankInfo="{ row }">
        <div>
          {{ row.bankName ? row.bankName : '--' }}
        </div>
        <div>
          {{ row.bankAccountName ? row.bankAccountName : '--' }}
        </div>
        <div>
          {{ row.bankAccountNo ? row.bankAccountNo : '--' }}
        </div>
        <div v-if="row.bankCount > 1">
          <el-tag size="mini">
            {{ row.bankCount }}
            {{ $l('INDEX.tips_bank_accounts') || '个银行账号' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.scmStatus === 'Y'
              ? 'success'
              : row.scmStatus === 'P'
              ? 'primary'
              : 'danger'
          "
        >
          {{ row.scmStatusName }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_view') || '查看'"
            placement="top"
          >
            <i class="el-icon-view tool-btn" @click="fromView(row.scmCode)"></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="fromLoad('edit', row.scmCode)"
              v-if="allow('M')"
              v-show="row.scmStatus === 'Y' || row.scmStatus === 'B'"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del([row])"
              v-show="row.scmStatus === 'Y' || row.scmStatus === 'B'"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_audit') || '审核'"
            placement="top"
          >
            <i
              v-show="
                row.scmStatus === 'B' ||
                  (row.scmStatus === 'Y' && row.scmMode === 'A')
              "
              class="el-icon-check tool-btn"
              @click="audit(row.scmCode)"
              v-if="allow('C')"
            ></i>
          </el-tooltip> -->
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
        custom: true,
      },
      allChecked: false,
      indeterminate: false,
      selected: [],
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          headerAlign: 'center',
          align: 'center',
          type: 'seq',
        },
        {
          field: 'scmName',
          headerAlign: 'left',
          align: 'left',
          minWidth: 300,
          title: this.$l('table_scm_label_scmName') || '供应商',
          slots: {
            default: 'scmName',
          },
        },
        {
          field: 'scmMode',
          headerAlign: 'left',
          align: 'left',
          minWidth: 250,
          showHeaderOverflow: 'title',
          title: this.$l('form_label_supply_chain_model') || '合作模式',
          slots: { default: 'scmMode' },
        },
        {
          field: 'scmAddressInfo',
          minWidth: 300,
          title: this.$l('table_label_supply_detailed_address') || '详细地址',
          headerAlign: 'left',
          align: 'left',
          slots: { default: 'scmAddressInfo' },
        },
        {
          field: 'bankInfo',
          minWidth: 300,
          title: this.$l('table_lable_bank') || '银行账户',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          align: 'left',
          slots: { default: 'bankInfo' },
        },
        {
          field: 'status',
          minWidth: 100,
          title: this.$l('table_label_status') || '状态',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          align: 'center',
          slots: { default: 'status' },
        },
        {
          field: 'createInfo',
          headerAlign: 'left',
          align: 'left',
          width: 170,
          title: this.$l('INDEX.creator') || '创建人',
          showHeaderOverflow: 'title',
          slots: { default: 'createInfo' },
        },
        {
          field: 'modifyInfo',
          headerAlign: 'left',
          align: 'left',
          width: 170,
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          showHeaderOverflow: 'title',
          slots: { default: 'modifyInfo' },
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 160,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
      ],
    }
  },
  activated() {
    this.reload()
  },
  methods: {
    // audit(val) {
    //   this.$confirm(this.$l('INDEX.tips_question_audit') || '是否审核？', {
    //     confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
    //     cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       this.$api.scmInfoAuditApi({ scmCode: val }).then((res) => {
    //         this.$message({
    //           showClose: true,
    //           message: res.msg,
    //           type: 'success'
    //         })
    //       })
    //     })
    //     .catch(() => {})
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    fromView(val = '') {
      let params = {
        pageType: 'view',
        scmCode: val,
      }
      // 跳转页面
      this.$router.push({
        name: 'resourceManagement-scmInfoDetail',
        params: params,
      })
    },
    // 加载表单
    fromLoad(ref, val = '') {
      if (ref === 'add') {
        val = null
      }
      let params = {
        pageType: ref,
        scmCode: val,
      }
      // 跳转页面
      this.$router.push({
        name: 'resourceManagement-scmInfoTemp',
        params: params,
      })
    },
    delRows() {
      let selection = this.selected
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据',
          type: 'warning',
        })
        return
      }
      this.del(selection)
    },
    del(array) {
      this.$confirm(this.$l('INDEX.tips_question_delete') || '是否删除？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.scmInfoUpdateStatusApi({ scmList: array }).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功',
              type: 'success',
            })
            this.$emit('submit')
          })
        })
        .catch(() => {})
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    reload() {
      this.$emit('submit')
    },
    onRowSelected(items) {
      this.selected = items
      if (items.length === 0) {
        this.indeterminate = false
        this.allChecked = false
      } else if (items.length === this.tableData.length) {
        this.indeterminate = false
        this.allChecked = true
      } else {
        this.indeterminate = true
        this.allChecked = false
      }
    },
    // 选中单行
    selectRow(index) {
      let isRowSelected = this.$refs.table.isRowSelected(index)
      if (isRowSelected) {
        this.$refs.table.unselectRow(index)
      } else {
        this.$refs.table.selectRow(index)
      }
    },
    // 表格全选/取消全选
    selectAllRows() {
      if (!this.allChecked) {
        this.$refs.table.selectAllRows()
      } else {
        this.$refs.table.clearSelected()
      }
    },
  },
}
</script>
